import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';

@Component({
  selector: 'apm-sidebar-content',
  templateUrl: './sidebar-content.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ApmSidebarContentComponent {
  @HostBinding('class') class = 'overflow-y-auto';
}
